import React from 'react'
import moment from 'moment'

import { StyledDatePicker } from './styles'

export const datePickerFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { field, fn } = formatExtraData

  return (
    <StyledDatePicker
      onChange={date => fn(date, row, field, rowIndex)}
      value={moment(row[field]).toDate()}
    />
  )
}
